export default "__VITE_ASSET__d$8qBDdy__"